import styled from 'styled-components';

export const FooterDiv = styled.footer`
  position: relative;
  width: 100%;
  margin-top: auto;
  overflow: hidden;
  background: #000;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  color: var(--white);
  &::before {
    content: '';

    position: absolute;
    top: 0;
    right: 0;

    width: 50%;
    height: 100%;

    background: radial-gradient(
        circle at 90% 20%,
        rgba(255, 210, 66, 0.14),
        transparent 34%
      ),
      linear-gradient(
        90deg,
        transparent 0%,
        rgba(242, 175, 23, 0.06) 58%,
        rgba(230, 139, 7, 0.08) 100%
      );

    pointer-events: none;
  }
`;

export const FooterInner = styled.div`
  position: relative;
  z-index: 2;
  width: min(100%, 1480px);

  margin: 0 auto;

  padding: var(--space-xxxxl) var(--space-xxxl) var(--space-xl);

  @media screen and (max-width: 900px) {
    padding: var(--space-xxxl) var(--space-xl) var(--space-l);
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-xxl) var(--space-m) var(--space-l);
  }
`;

export const FooterRow = styled.div`
  display: grid;
  grid-template-columns: 1.3fr 1fr 1fr 1fr;

  gap: var(--space-xxxl);

  padding-bottom: var(--space-xxxl);

  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  @media screen and (max-width: 950px) {
    grid-template-columns: repeat(2, 1fr);

    gap: var(--space-xxl);
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;

    gap: var(--space-xl);
  }
`;

export const FooterBrand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  img {
    width: auto;
    height: 68px;

    margin-bottom: var(--space-m);

    display: block;
  }

  p {
    max-width: 320px;

    margin: 0;

    color: rgba(255, 255, 255, 0.68);

    font-size: 0.95rem;
    line-height: 1.8;
    font-weight: 500;
  }

  @media screen and (max-width: 600px) {
    img {
      height: 56px;
    }
  }
`;

export const FooterCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-s);

  min-width: 0;

  h5 {
    margin: 0 0 var(--space-s) 0;

    color: var(--white);

    font-size: 0.82rem;
    font-weight: 900;

    text-transform: uppercase;
    letter-spacing: 0.14em;
  }

  p {
    margin: 0;

    color: rgba(255, 255, 255, 0.7);

    font-size: 0.95rem;
    line-height: 1.7;
    font-weight: 500;
  }

  @media screen and (max-width: 600px) {
    gap: var(--space-xs);
  }
`;

export const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;

  gap: var(--space-s);

  a {
    width: fit-content;

    color: rgba(255, 255, 255, 0.72);

    text-decoration: none;

    font-size: 0.95rem;
    font-weight: 600;

    transition:
      color 0.2s ease,
      transform 0.2s ease;

    &:hover {
      color: var(--yellow4);

      transform: translateX(2px);
    }
  }
`;

export const FooterBottomRow = styled.div`
  padding-top: var(--space-l);

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: var(--space-m);

  @media screen and (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FooterBottomItem = styled.div`
  color: rgba(255, 255, 255, 0.52);

  font-size: 0.88rem;
  line-height: 1.6;
  font-weight: 500;
`;

export const FooterBottomLinks = styled.div`
  display: flex;
  align-items: center;

  gap: var(--space-s);

  span {
    color: rgba(255, 255, 255, 0.28);
  }

  a {
    color: rgba(255, 255, 255, 0.58);

    text-decoration: none;

    font-size: 0.88rem;
    font-weight: 600;

    transition: color 0.2s ease;

    &:hover {
      color: var(--yellow4);
    }
  }

  @media screen and (max-width: 600px) {
    flex-wrap: wrap;
  }
`;
export const FooterCredit = styled.div`
  color: rgba(255, 255, 255, 0.38);
  font-size: 0.85rem;
  font-weight: 500;
  a {
    color: var(--yellow4);
    text-decoration: underline;
    font-weight: 700;
    transition: color 0.2s;
    &:hover {
      color: var(--white);
    }
  }
  @media screen and (max-width: 700px) {
    margin-top: var(--space-m);
  }
`;

export const FooterPWASection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-xl);

  padding: var(--space-xl) 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  @media screen and (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const FooterPWAContent = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-l);

  @media screen and (max-width: 600px) {
    align-items: flex-start;
    gap: var(--space-m);
  }
`;

export const FooterPWAIcon = styled.div`
  width: 62px;
  height: 62px;
  flex-shrink: 0;

  display: grid;
  place-items: center;

  background: rgba(255, 210, 66, 0.1);
  border: 1px solid rgba(255, 210, 66, 0.2);
  border-radius: 14px;

  color: var(--yellow4);
  font-size: 26px;

  @media screen and (max-width: 600px) {
    width: 48px;
    height: 48px;
    font-size: 22px;
  }
`;

export const FooterPWAText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  span {
    color: var(--yellow4);
    font-size: 0.72rem;
    font-weight: 900;
    letter-spacing: 0.14em;
  }

  h3 {
    margin: 0;
    color: var(--white);
    font-size: clamp(1.15rem, 2vw, 1.45rem);
    font-weight: 800;
    line-height: 1.3;
  }

  p {
    max-width: 550px;
    margin: 0;
    color: rgba(255, 255, 255, 0.65);
    font-size: 0.9rem;
    line-height: 1.7;
  }
`;

export const FooterPWAButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-shrink: 0;

  padding: 14px 22px;

  background: var(--yellow4);
  color: #111;

  border: none;
  border-radius: 8px;

  font-size: 0.9rem;
  font-weight: 800;

  cursor: pointer;

  transition:
    background 0.2s ease,
    transform 0.2s ease;

  &:hover {
    background: #ffda65;
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 3px;
  }

  @media screen and (max-width: 700px) {
    width: 100%;
  }
`;
